import Vue from 'vue'

function ifEmpty (val, def) {
  if (val === null || val === '') {
    return def
  }
  return val
}

Vue.filter('ifEmpty', ifEmpty)
